import { SearchDetailsQueryState } from 'components/shared/SearchDetailsView'
import { DateOperator,SessionSearchState } from 'redux/slices'
import {
    createEnumParam,
    DecodedValueMap,
    QueryParamConfigMap,
    SetQuery,
    StringParam,
    useQueryParams,
    withDefault,
} from 'use-query-params'
import { withIgnoreBlanks } from 'utils/custom-query-params'
import { ColumnStateQueryParam, ColumnStateQueryState } from 'utils/useColumnStateManager'

type QueryState = SessionSearchState & SearchDetailsQueryState & ColumnStateQueryState

export const useSessionQueryParams = (): {
    query: DecodedValueMap<QueryParamConfigMap>
    setQuery: SetQuery<QueryParamConfigMap>
    search: QueryState
} => {
    const [query, setQuery] = useQueryParams({
        keyword: withDefault(withIgnoreBlanks(StringParam), undefined),
        versionConfigFields: withDefault(withIgnoreBlanks(StringParam), undefined),
        sessionName: withDefault(withIgnoreBlanks(StringParam), undefined),
        email: withDefault(withIgnoreBlanks(StringParam), undefined),
        classifierName: withDefault(
            withIgnoreBlanks(createEnumParam(Object.keys(DateOperator))),
            undefined
        ),
        sampleID: withDefault(withIgnoreBlanks(StringParam), undefined),
        runIds: withDefault(withIgnoreBlanks(StringParam), undefined),
       
        ...ColumnStateQueryParam,
    })
    const search = query as QueryState

    return { query, setQuery, search }
}

export default useSessionQueryParams
